<script lang="ts">
  import { onMount, untrack, type Snippet } from "svelte";
  import { createWorkflow, type Step, type Aside, type Workflow, type WorkflowState } from "./workflowLib.svelte";

  let {
    workflow = $bindable<Workflow>(),
    step = $bindable<Step | Workflow>(),
    aside = $bindable<Aside>(),
    active = $bindable<boolean>(),
    state: workflowState = {},
    onchange,
    children,
  }: {
    workflow?: Workflow;
    step?: Step | Workflow | null;
    aside?: Aside | null;
    active?: boolean;
    state?: WorkflowState;
    onchange?: (workflow: Workflow) => any;
    children: Snippet;
  } = $props();

  const me = createWorkflow();
  let lastStep = $state<Workflow | Step | null>(null);
  let lastAside = $state<Aside | null>(null);
  let lastActive = $state<boolean>(false);

  $effect(() => {
    workflow = me;
    step = me.currentStep;
    aside = me.currentAside;
    active = me.active;
    me.state = workflowState;
    untrack(() => {
      if (onchange && (step != lastStep || aside != lastAside || active != lastActive)) onchange(me);
      lastStep = step;
      lastAside = aside;
      lastActive = active;
    });
  });
  onMount(() => me.close()); // Steps should not be added after initial mount; close() allows us to warn if they are
</script>

<div style="display: {me.active ? 'contents' : 'none'}">
  {@render children()}
</div>
